export const LOAN_TYPES = [
  {
    value: 'Line of Credit',
    label: 'Line of Credit',
  },
  {
    value: 'Term Loan',
    label: 'Term Loan',
  },
  {
    value: 'Equipment Lease',
    label: 'Equipment Lease',
  },
  {
    value: 'Letter of Credit',
    label: 'Letter of Credit',
  },
  {
    value: 'Commercial Mortgage',
    label: 'Commercial Mortgage',
  },
  {
    value: 'Other (Type/paste and hit "Create"...)',
    label: 'Other (Type/paste and hit "Create"...)',
  },
];
